import { classNames } from "./classNames";

/** What a chip says about its subject; the domain maps its own states onto these. */
export type ChipTone = "neutral" | "info" | "success" | "warning" | "danger";
/** `compact` inside dense rows and graph cards, `small` in running text, `regular` beside a heading. */
export type ChipSize = "compact" | "small" | "regular";

const TONE_CLASS: Readonly<Record<ChipTone, string>> = {
  neutral: "",
  info: "app-chip-info",
  success: "app-chip-success",
  warning: "app-chip-warning",
  danger: "app-chip-danger",
};

const SIZE_CLASS: Readonly<Record<ChipSize, string>> = {
  compact: "px-1.5 py-0 text-[10px]",
  small: "px-1.5 py-0.5 text-xs",
  regular: "px-2 py-1 text-sm",
};

/** The colour of a tone alone, for a domain map that is still read as classes. */
export function chipToneClass(tone: ChipTone): string {
  return TONE_CLASS[tone];
}

/** A chip's look, for the Chip component and for buttons or links that look like one. */
export function chipClassName(tone: ChipTone = "neutral", size: ChipSize = "small"): string {
  return classNames("app-chip inline-flex items-center gap-1", TONE_CLASS[tone], SIZE_CLASS[size]);
}
